import React from 'react'
import { SearchBarProps } from './types'
import InputText from '@sharedComponents/InputText'
import { KEYS } from "@apps/Shared/Constants/KeyCodes";
import Icon from '@sharedComponents/Icon'
import { useTranslation } from 'react-i18next'
import {usePantameraService} from "@frontendUtils/pantamera-service";
const { getCssVariable } = usePantameraService();

const SearchBar = (props: SearchBarProps) => {
    const { t } = useTranslation()

    const iconColor = getCssVariable('search-icon-color');

    const onChange = (e: any) => {
        const value = e.target.value
        props.onChange(value)
    }

    const doSearch = () => {
        props.doSearch()
    }

    return (
        <div className="search-bar">
            <div className="search-bar__icon-container">
                <Icon iconName="search" color={iconColor} />
            </div>
            <InputText
                id="search-page-search-input"
                label={t('placeholder.search')}
                hideLabel={true}
                value={props.value}
                onChange={onChange}
                onKeyUp={(e: any) => {
                    if (e.keyCode === KEYS.enter) {
                        doSearch()
                    }
                }}
            />
        </div>
    )
}

export default SearchBar
